import { Toast } from 'antd-mobile';
import wxPay from './wx'

// 利用时间戳实现防抖算法，默认300毫秒
let timer:any = null;
const clearTimer = () => {
  clearTimeout(timer)
  timer = null
}

export const debounce = (fn: Function, delay:number = 300) => {
  if(timer) clearTimer()

  timer = setTimeout(() => {
    fn()
    timer = null
  }, delay)
}

// 节流
export const throttle = (fn: Function, delay:number = 500) => {
  let last: number = 0;
  const now = Date.now();

  if (now - last > delay) {
    last = now;
    fn()
  }
}

const u = navigator.userAgent
export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
// /Macintosh/.test(u) && /AppleWebKit/.test(u) && !/Safari/.test(u)
export const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || /Mac OS|iPad|iPhone|iPod/i.test(u) //ios终端
export const isWeChat = /MicroMessenger/.test(u)
export const isWeChatMini = /miniProgram/i.test(u)
export const isWindows = u.includes('Windows') //Windows系统
export const isMac = u.includes('Intel Mac OS') //Mac系统

// 调用原生方法返回
export const onReturn = () => {
  try {
    if (isWeChat) {
      wxPay.closeWindow()
    }
    else if (isAndroid) {
      window.nativeObject?.close()
    }
    else if (isiOS) {
      window.webkit?.messageHandlers?.close?.postMessage(null);
    }
    else if (isWindows) {
      window.flutter_inappwebview?.callHandler('close')
    }

    window.location.replace('/')
  } catch (error:any) {
    console.log(error)
  }
}

// 调用原生方法跳转到用户信息页
export const onToUserPage = (id: number | string, actiontype:string = 'homepage', showTabIndex:number | string = "0") => {
  // actionType(跳转页面标识): 
  // live_room 直播间（参数需要带房间ID(voice_id)）参考：{"actiontype":"live_room","params":{"id":"123"},"title":"直播间名称"}
  // user_bag 用户背包
  // user_relation_remove_apply 关系解除申请
  // user_relation_remove_result 关系强制解除/同意关系解除申请/拒绝关系解除申请
  // webView 内部浏览器打开h5 {"actiontype":"webView","params":{"id":"https://www.baidu.com"},"title":"国庆活动"}
  // recharge 充值页面 {"actiontype":"recharge"}
  // homepage 用户个人主页 {"actiontype":"homepage", "params": {"id": "20221284","showTabIndex":"0"}} --showTabIndex为可选参数，可设置个人主页底部默认选中的Tab
  // noble 贵族中心 {"actiontype":"noble"}
  // user_honor_center 荣誉中心{"actiontype":"user_honor_center","params": {"id": "20221284"}}
  // honor_list 荣誉殿堂{"actiontype":"honor_list","params": {"id": "love"}} id对应的榜单：（真爱：love，魅力：anchor，成就：user，礼物：gift，贵族：noble，PK：pk，游戏：game，周星：weekstar）
  // external_browser 外部浏览器打开h5 {"actiontype":"external_browser","params":{"id":"https://www.baidu.com"}}
  // ai_intelligent AI互动{"actiontype":"ai_intelligent"}
  // dynamic_detail 动态详情页{"actiontype":"dynamic_detail","params": {"id": "70"}}
  const obj = `{ "actiontype": "${actiontype}", "params": {"id":  "${id.toString()}", "showTabIndex": "${showTabIndex.toString()}"}, "title": "" }`

  if (isWindows) window.flutter_inappwebview?.callHandler('uuaudio', `uuaudio://action?dp_params=${encodeURIComponent(obj)}`)
  else window.location.href = `uuaudio://action?dp_params=${encodeURIComponent(obj)}`
}

// 处理键盘弹出遮挡输入框的问题
export const inputScrollView = (input:Element) => {
  const topHeight = document.body.scrollHeight;

  setTimeout(() => {
    if (isiOS) {
      if (!/OS 11_[0-3]\D/.test(u)) {
        document.body.scrollTop = topHeight;   
      }
    } else {
      input.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    }
  }, 200);
}

// 判断用户是否安装了支付宝  0表示没有安装，1表示有，字符串类型
export const haveAlipay = () => {
  try {
    if (isAndroid) {
      const has:string = window.nativeObject?.haveAlipay()
      window.getHasAlipay(has)
    }
    else if (isiOS) {
      window.webkit?.messageHandlers?.havezf?.postMessage(null);
    }
  } catch (error:any) {
    console.log(error)
  }
}

export const isMQQ = () => {
  var _UA = window.navigator.userAgent;
  if(/QQ\/\d/i.test(_UA)){
      return true;
  }
  return false;
}

export const isWechat = () => {
  var _UA = window.navigator.userAgent;
  if(/micromessenger/i.test(_UA.match(/MicroMessenger/i)?.toString() || '')) {
      return true;
  }
  return false;
}

export const isAliPay = () => {
  var _UA = window.navigator.userAgent;
  if(/AlipayClient/i.test(_UA)){
      return true;
  }
  return false;
}

export const checkPhoneBranch = () => {
  const appInfo = navigator.userAgent;
  const ios = !!appInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const iPad = appInfo.indexOf("iPad") > -1;
  const iPhone = appInfo.indexOf("iPhone") > -1 || appInfo.indexOf("Mac") > -1;
  const Android = appInfo.indexOf("Android") > -1 || appInfo.indexOf("Adr") > -1;
  const HarmonyOS = appInfo.indexOf("ohos") > -1
  return (ios || iPad || iPhone) ? 'IOS' : Android ? 'Android' : HarmonyOS ? 'HarmonyOS' : '其他'
}

export const jumpPage = (page:string) => {
  window.location.href = page
}

export const isMobile = () => {
  const isPhone = /Mobi/i.test(navigator.userAgent) || 'ontouchstart' in window || (navigator.maxTouchPoints > 0) || ((navigator as any).msMaxTouchPoints > 0);
  const clientWidth = document.body?.clientWidth || 390

  return isPhone || clientWidth <= 850
}

const execCommand = (textArea: any) => {
  // 使text area不在viewport，同时设置不可见
  textArea.style.position = "absolute";
  textArea.style.opacity = "0";
  textArea.style.left = "-999999px";
  textArea.style.top = "-999999px";
  document.body.appendChild(textArea);
  // textArea.focus();
  textArea.select();
  new Promise((resolve, reject) => {
    // 执行复制命令并移除文本框
    document.execCommand("copy") ? resolve(textArea.value) : reject(new Error("复制失败"));
    textArea.remove();
  }).then(() => {
    Toast.show('复制成功')
  }).catch(() => {
    Toast.show('浏览器复制功能被禁止，请检查浏览器设置！')
  })
}

export const ToggleCopy = async (text = '') => {
  const textArea = document.createElement("textarea");
  textArea.value = text.toString().replace(/"/g, '');
  
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(textArea.value);
      Toast.show('复制成功')
    } catch (err) {
      // Toast.show('浏览器复制功能被禁止，请检查浏览器设置！')
      execCommand(textArea)
    }
  } else {
    execCommand(textArea)
  }
}

// 获取路径参数
export const getUrlParams = (name:string) => {
  return new URLSearchParams(window.location.search).get(name) || ''
}

// 打开iOS app
export const openApp = (id: number | string, actiontype:string = 'homepage', showTabIndex:number | string = "0") => {
  const obj = `{ "actiontype": "${actiontype}", "params": {"id":  "${id.toString()}", "showTabIndex": "${showTabIndex.toString()}"}, "title": "" }`

  window.location.href = `itms-apps://itunes.apple.com/cn/app/id6773612899?mt=8&dp_params=${encodeURIComponent(obj)}`;
}
